import { useCallback, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import useMergeProps from '../../../../hooks/useMergeProps';
import {
  setGRHomeVisitedIndex as setGRHomeVisitedIndexAction,
  triggerGRNotificationsTransitions as triggerGRNotificationsTransitionsAction,
  cancelNotificationsTransitions as cancelNotificationsTransitionsAction,
} from '../../actions/gr';

import GRHome from './GRHome';
import selectGRHomeProps from './GRHome.selector';

type GRHomeContainerProps = {
  className?: string;
};

const GRHomeContainer = (ownProps: GRHomeContainerProps) => {
  const dispatch = useDispatch();
  const selectedProps = useSelector(selectGRHomeProps);

  const setIndex = useCallback(
    (index: number): void => {
      dispatch(setGRHomeVisitedIndexAction(index));
    },
    [dispatch],
  );

  const triggerNotificationsTransitions = useCallback((): void => {
    dispatch(triggerGRNotificationsTransitionsAction());
  }, [dispatch]);

  const cancelNotificationsTransitions = useCallback((): void => {
    dispatch(cancelNotificationsTransitionsAction());
  }, [dispatch]);

  const otherProps = useMemo(
    () => ({
      setIndex,
      triggerNotificationsTransitions,
      cancelNotificationsTransitions,
    }),
    [cancelNotificationsTransitions, setIndex, triggerNotificationsTransitions],
  );

  const { endingLabel, ...enhancedProps } = useMergeProps({ ownProps, selectedProps, otherProps });

  if (endingLabel) {
    return <GRHome {...enhancedProps} endingLabel={endingLabel} />;
  }

  return null;
};

export default GRHomeContainer;
